import { useEffect, useMemo } from 'react';
import { useHttpService } from './async';

const useServiceApi = (serviceApiFactory) => {
    const abortController = new AbortController();
    const httpService = useHttpService(abortController);

    useEffect(() => {
        return () => {
            abortController.abort();
        }
    }, []);

    return useMemo(
        () => serviceApiFactory(httpService),
        [httpService, serviceApiFactory]
    );
};

export { useServiceApi };